import { CellContext } from '@tanstack/react-table';
import { Meta, TopAudiosTableRow } from '../../TopAudiosTable';
import { getTableMetaHelper, Image, SkeletonizedValue } from '@round/ui-kit';
import { TooltipOnOverflow } from '@round/whitelabel-ui';
import styles from './AudioCell.module.css';

export type AudioCellData = {
    audioUrl: string;
    songTitle: string;
    thumbnailUrl: string;
};
type Context<T extends TopAudiosTableRow> = CellContext<T, AudioCellData>;

const getTableMeta = getTableMetaHelper<Meta>();

const AudioCell = <T extends TopAudiosTableRow>({ row, table, getValue }: Context<T>) => {
    const { isLoading } = getTableMeta(table);
    const { audioUrl, songTitle, thumbnailUrl } = getValue();

    return (
        <div className={styles.audioContainer}>
            <Image src={thumbnailUrl} alt={songTitle} className={styles.audioThumbnail} skeletonCircle={false} />
            <SkeletonizedValue width="10rem" isInitialized={!isLoading}>
                <TooltipOnOverflow tooltip={songTitle}>
                    {audioUrl ? (
                        <a href={audioUrl} rel={'noopener noreferrer'} target={'_blank'} className={styles.audioTitle}>
                            {songTitle}
                        </a>
                    ) : (
                        <span className={styles.audioTitle}>{songTitle}</span>
                    )}
                </TooltipOnOverflow>
            </SkeletonizedValue>
        </div>
    );
};

export default AudioCell;
